import {differenceInYears} from "date-fns";

export const have18 = (date) => {
    const years = differenceInYears(new Date(), date);
    if (years >= 18) {
        return true;
    }

    return false;
};